import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends ApiService {
  public saveFcmToken(reqData: any): Observable<any> {
    return this.post<any>(ROUTES.SAVE_FCM_TOKEN, {
      body: reqData,
    });
  }
}
